import * as React from "react"
import "./index.scss"

const SwitchingContainer: React.FC = (props) => {
	const { children } = props

	return (
		<div
			data-testid="switching-breakdown-component"
			className="customer-behavior-switching"
		>
			{children}
		</div>
	)
}

export default SwitchingContainer
